export default __webpack_public_path__ + "static/cover-applozic-fa91009e6a85d95c85d63a1fc650b987.png";